// eslint-disable-next-line import/prefer-default-export
export const appLanguageSelector = (state) => state.newApp.language.language;
